import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const collections = [{
  title: 'TriLyn Collection',
  description: 'Our signature handcrafted pieces celebrating authentic African heritage.',
  image: 'https://cdn.magicpatterns.com/uploads/ok2GGtft3ausR8pfW3rEvG/pasted-image.png'
}, {
  title: 'Victoria By TriLyn',
  description: 'Elegant jewelry and accessories designed for the modern queen.',
  image: 'https://cdn.magicpatterns.com/uploads/dnFBiLf42a99KfYUr626ET/pasted-image.jpg'
}, {
  title: 'Zarrito By TriLyn',
  description: 'Bold, contemporary apparel that makes a powerful cultural statement.',
  image: 'https://cdn.magicpatterns.com/uploads/hJK2Ni62uBRFVioU1Qp6bW/pasted-image.jpg'
}, {
  title: 'Clearance',
  description: 'Last chance to own these timeless pieces at exceptional prices.',
  image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?q=80&w=1972&auto=format&fit=crop'
}];
export function FeaturedCollections() {
  return <section className="py-20 bg-white" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-104">
          <h2 className="text-3xl md:text-5xl font-serif mb-4 uppercase tracking-widest leading-tight" data-id="element-105">
            Featured Collections
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-106"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-107">
          {collections.map((collection, index) => <motion.div key={collection.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="group flex flex-col h-full" data-id="element-108">
              <div className="relative overflow-hidden aspect-video mb-4" data-id="element-109">
                <img src={collection.image} alt={collection.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-110" />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-300" data-id="element-111" />
              </div>
              <div className="flex flex-col flex-grow text-center px-2" data-id="element-112">
                <h3 className="text-lg md:text-2xl font-serif mb-2 md:mb-3 group-hover:text-gold transition-colors" data-id="element-113">
                  {collection.title}
                </h3>
                <p className="text-gray-600 text-xs md:text-base mb-4 md:mb-6 flex-grow leading-relaxed" data-id="element-114">
                  {collection.description}
                </p>
                <Link to="/shop" className="border-b border-black pb-1 text-xs uppercase tracking-widest font-bold self-center hover:text-gold hover:border-gold transition-all duration-300" data-id="element-115">
                  Shop Now
                </Link>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}